import React, { useEffect, useState, useRef } from 'react';
import { kullaniciApi, tanimlarApi } from '../services/api';

export default function Kullanicilar() {
  const [kullanicilar, setKullanicilar] = useState<any[]>([]);
  const [roller, setRoller] = useState<any[]>([]);
  const [isletmeler, setIsletmeler] = useState<any[]>([]);
  const [orgBirimler, setOrgBirimler] = useState<any[]>([]);
  const [arama, setArama] = useState('');
  const [pasifGoster, setPasifGoster] = useState(false);
  const [modalAcik, setModalAcik] = useState(false);
  const [sifreModal, setSifreModal] = useState(false);
  const [secili, setSecili] = useState<any>(null);
  const [form, setForm] = useState<any>({});
  const [yeniSifre, setYeniSifre] = useState('');
  const [hata, setHata] = useState('');

  // Personel arama
  const [personelArama, setPersonelArama] = useState('');
  const [personelSonuclar, setPersonelSonuclar] = useState<any[]>([]);
  const [personelAraYukleniyor, setPersonelAraYukleniyor] = useState(false);
  const [bagliPersonel, setBagliPersonel] = useState<any>(null);
  const personelAraTimer = useRef<any>(null);

  const yukle = () => kullaniciApi.list().then(r => setKullanicilar(r.data));

  useEffect(() => {
    yukle();
    tanimlarApi.roller().then(r => setRoller(r.data));
    tanimlarApi.isletmelerListesi().then(r => setIsletmeler(r.data));
    tanimlarApi.orgBirimlerListesi().then(r => setOrgBirimler(r.data));
  }, []);

  const filtreli = kullanicilar.filter(k => {
    if (!pasifGoster && !k.aktif) return false;
    return k.ad_soyad.toLowerCase().includes(arama.toLowerCase()) ||
      k.kullanici_adi.toLowerCase().includes(arama.toLowerCase());
  });

  const yeniAc = () => {
    setSecili(null);
    setForm({ rol: 'isletme_personel' });
    setHata('');
    setBagliPersonel(null);
    setPersonelArama('');
    setPersonelSonuclar([]);
    setModalAcik(true);
  };

  const duzenleAc = (k: any) => {
    setSecili(k);
    setForm({ ...k });
    setHata('');
    setBagliPersonel(k.personel_id ? { id: k.personel_id, ad_soyad: k.ad_soyad, email: k.email } : null);
    setPersonelArama('');
    setPersonelSonuclar([]);
    setModalAcik(true);
  };

  const kapat = () => {
    setModalAcik(false);
    setSifreModal(false);
    setSecili(null);
    setForm({});
    setHata('');
    setYeniSifre('');
    setBagliPersonel(null);
    setPersonelArama('');
    setPersonelSonuclar([]);
  };

  // Personel arama — TC kimlik no (11 hane) ise anında tam eşleşme, diğer girişlerde debounce
  const personelAramaYap = (q: string) => {
    setPersonelArama(q);
    if (personelAraTimer.current) clearTimeout(personelAraTimer.current);
    const temiz = q.replace(/\D/g, '');
    if (q.length < 2) { setPersonelSonuclar([]); setPersonelAraYukleniyor(false); return; }

    const ara = async () => {
      setPersonelAraYukleniyor(true);
      try {
        const params = temiz.length === 11 ? { tc: temiz } : { q };
        const r = await kullaniciApi.personelAra(params.q || '', params.tc);
        setPersonelSonuclar(r.data);
      } catch { setPersonelSonuclar([]); }
      finally { setPersonelAraYukleniyor(false); }
    };

    if (temiz.length === 11) {
      ara();
    } else {
      setPersonelAraYukleniyor(true);
      personelAraTimer.current = setTimeout(ara, 200);
    }
  };

  const personelSec = (p: any) => {
    setBagliPersonel(p);
    setForm((f: any) => ({
      ...f,
      personel_id: p.id,
      ad_soyad: p.ad_soyad,
      email: p.email || f.email,
      isletme_id: p.isletme_id || f.isletme_id,
    }));
    setPersonelArama('');
    setPersonelSonuclar([]);
  };

  const personelBagKopar = () => {
    setBagliPersonel(null);
    setForm((f: any) => ({ ...f, personel_id: secili ? 0 : undefined }));
  };

  const kaydet = async () => {
    setHata('');
    if (!form.ad_soyad?.trim()) { setHata('Ad soyad zorunludur'); return; }
    if (!form.kullanici_adi?.trim()) { setHata('Kullanıcı adı zorunludur'); return; }
    if (!secili && !form.sifre?.trim()) { setHata('Şifre zorunludur'); return; }
    if (!form.rol) { setHata('Rol seçimi zorunludur'); return; }
    if (isletmeGerekli && !form.isletme_id) { setHata('Bu rol için işletme seçimi zorunludur'); return; }
    try {
      if (secili) {
        await kullaniciApi.update(secili.id, form);
      } else {
        await kullaniciApi.create({ ...form });
      }
      yukle();
      kapat();
    } catch (e: any) {
      setHata(e.response?.data?.detail || 'Bir hata oluştu');
    }
  };

  const sifreDegistir = async () => {
    if (!yeniSifre || yeniSifre.length < 6) { setHata('Şifre en az 6 karakter olmalı'); return; }
    try {
      await kullaniciApi.sifreDegistir(secili.id, yeniSifre);
      kapat();
      alert('Şifre güncellendi');
    } catch (e: any) { setHata('Hata oluştu'); }
  };

  const sil = async (id: number) => {
    if (!window.confirm('Bu kullanıcıyı pasif yapmak istiyor musunuz?')) return;
    await kullaniciApi.delete(id);
    yukle();
  };

  const aktifEt = async (id: number) => {
    await kullaniciApi.update(id, { aktif: true });
    yukle();
  };

  const rolAd = (kod: string) => roller.find(r => r.kod === kod)?.ad || kod;
  const isletmeAd = (id: number) => isletmeler.find(i => i.id === id)?.ad || '-';

  const isletmeGerekli = form.rol && ['isletme_mudur', 'isletme_personel'].includes(form.rol);
  const personelBagliMi = !!bagliPersonel;

  return (
    <div>
      <div className="page-header">
        <h1>👥 Kullanıcı Yönetimi</h1>
        <p>Sistem kullanıcıları ve yetkilendirme yönetimi</p>
      </div>

      <div className="card">
        <div className="toolbar">
          <input className="search-input" placeholder="İsim veya kullanıcı adı ara..." value={arama} onChange={e => setArama(e.target.value)} />
          <label style={{ display: 'flex', alignItems: 'center', gap: 6, fontSize: 13, color: '#666', cursor: 'pointer' }}>
            <input type="checkbox" checked={pasifGoster} onChange={e => setPasifGoster(e.target.checked)} />
            Pasifleri göster
          </label>
          <button className="btn btn-success" onClick={yeniAc}>+ Yeni Kullanıcı</button>
        </div>
        <div className="table-container">
          <table>
            <thead>
              <tr>
                <th>Ad Soyad</th>
                <th>Kullanıcı Adı</th>
                <th>Rol</th>
                <th>İşletme</th>
                <th>Personel</th>
                <th>Durum</th>
                <th>İşlem</th>
              </tr>
            </thead>
            <tbody>
              {filtreli.map(k => (
                <tr key={k.id}>
                  <td><strong>{k.ad_soyad}</strong></td>
                  <td>{k.kullanici_adi}</td>
                  <td>{rolAd(k.rol)}</td>
                  <td>{k.isletme_id ? isletmeAd(k.isletme_id) : k.birim_adi ? <span style={{ color: '#374151' }}>{k.birim_adi}</span> : <em style={{ color: '#999' }}>Genel Müdürlük</em>}</td>
                  <td>
                    {k.personel_id
                      ? <span style={{ color: '#27ae60', fontSize: 12 }}>✔ Bağlı</span>
                      : <span style={{ color: '#999', fontSize: 12 }}>Bağlı değil</span>}
                  </td>
                  <td><span className={`badge badge-${k.aktif ? 'aktif' : 'pasif'}`}>{k.aktif ? 'Aktif' : 'Pasif'}</span></td>
                  <td>
                    {k.aktif ? (
                      <>
                        <button className="btn btn-primary btn-sm" onClick={() => duzenleAc(k)} style={{ marginRight: 4 }}>Düzenle</button>
                        <button className="btn btn-sm" style={{ background: '#f39c12', color: 'white', marginRight: 4 }} onClick={() => { setSecili(k); setHata(''); setSifreModal(true); }}>Şifre</button>
                        <button className="btn btn-danger btn-sm" onClick={() => sil(k.id)}>Pasif Yap</button>
                      </>
                    ) : (
                      <button className="btn btn-sm" style={{ background: '#27ae60', color: 'white' }} onClick={() => aktifEt(k.id)}>Aktif Et</button>
                    )}
                  </td>
                </tr>
              ))}
              {filtreli.length === 0 && <tr><td colSpan={7} style={{ textAlign: 'center', color: '#999', padding: '20px' }}>Kayıt bulunamadı</td></tr>}
            </tbody>
          </table>
        </div>
      </div>

      {/* Kullanıcı Modal */}
      {modalAcik && (
        <div className="modal-overlay" onClick={kapat}>
          <div className="modal" onClick={e => e.stopPropagation()} style={{ maxWidth: 560 }}>
            <div className="modal-header">
              <h3>{secili ? 'Kullanıcı Düzenle' : 'Yeni Kullanıcı'}</h3>
              <button className="modal-close" onClick={kapat}>×</button>
            </div>
            <div className="modal-body">
              {hata && <div className="alert alert-danger">{hata}</div>}

              {/* Personel Bağlama */}
              <div style={{ background: '#f0f8ff', border: '1px solid #b3d9ff', borderRadius: 6, padding: 12, marginBottom: 16 }}>
                <div style={{ fontSize: 13, fontWeight: 600, color: '#1a5276', marginBottom: 8 }}>
                  Personel Kaydına Bağla (opsiyonel)
                </div>
                {personelBagliMi ? (
                  <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
                    <span style={{ color: '#27ae60', fontWeight: 600 }}>✔ {bagliPersonel.ad_soyad}</span>
                    {bagliPersonel.email && <span style={{ color: '#666', fontSize: 12 }}>— {bagliPersonel.email}</span>}
                    <button onClick={personelBagKopar} style={{ marginLeft: 'auto', background: 'none', border: '1px solid #e74c3c', borderRadius: 4, color: '#e74c3c', cursor: 'pointer', padding: '2px 8px', fontSize: 12 }}>
                      Bağı Kopar
                    </button>
                  </div>
                ) : (
                  <div style={{ position: 'relative' }}>
                    <input
                      className="form-control"
                      placeholder="TC kimlik no veya ad / soyad / sicil no..."
                      value={personelArama}
                      onChange={e => personelAramaYap(e.target.value)}
                      style={{ fontSize: 13 }}
                    />
                    {personelSonuclar.length > 0 && (
                      <div style={{ position: 'absolute', top: '100%', left: 0, right: 0, background: '#fff', border: '1px solid #ddd', borderRadius: 4, zIndex: 100, maxHeight: 200, overflowY: 'auto', boxShadow: '0 4px 8px rgba(0,0,0,0.1)' }}>
                        {personelSonuclar.map((p: any) => (
                          <div key={p.id} onClick={() => personelSec(p)}
                            style={{ padding: '8px 12px', cursor: 'pointer', borderBottom: '1px solid #f0f0f0', fontSize: 13 }}
                            onMouseEnter={e => (e.currentTarget.style.background = '#f5f5f5')}
                            onMouseLeave={e => (e.currentTarget.style.background = '#fff')}>
                            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                              <strong>{p.ad_soyad}</strong>
                              <span style={{ color: '#aaa', fontSize: 11 }}>{p.personel_turu}</span>
                            </div>
                            <div style={{ color: '#666', fontSize: 11, marginTop: 2 }}>
                              TC: <strong>{p.tc_kimlik_no || '—'}</strong>
                              <span style={{ marginLeft: 12 }}>Sicil: {p.sicil_no}</span>
                            </div>
                          </div>
                        ))}
                      </div>
                    )}
                    {personelAraYukleniyor && (
                      <div style={{ fontSize: 12, color: '#888', marginTop: 4 }}>Aranıyor...</div>
                    )}
                    {!personelAraYukleniyor && personelArama.length >= 2 && personelSonuclar.length === 0 && (
                      <div style={{ fontSize: 12, color: '#c0392b', marginTop: 4 }}>Uygun personel bulunamadı (zaten bağlı olanlar gösterilmez)</div>
                    )}
                  </div>
                )}
              </div>

              <div className="form-row">
                <div className="form-group">
                  <label>Ad Soyad *</label>
                  <input
                    className="form-control"
                    value={form.ad_soyad || ''}
                    onChange={e => setForm({ ...form, ad_soyad: e.target.value })}
                    disabled={personelBagliMi}
                    style={personelBagliMi ? { background: '#f9f9f9', color: '#555' } : {}}
                    placeholder={personelBagliMi ? 'Personel kaydından okunuyor' : ''}
                  />
                </div>
                <div className="form-group">
                  <label>Kullanıcı Adı *</label>
                  <input
                    className="form-control"
                    value={form.kullanici_adi || ''}
                    onChange={e => setForm({ ...form, kullanici_adi: e.target.value })}
                    disabled={!!secili}
                  />
                </div>
              </div>

              {!secili && (
                <div className="form-group">
                  <label>Şifre *</label>
                  <input className="form-control" type="password" value={form.sifre || ''} onChange={e => setForm({ ...form, sifre: e.target.value })} />
                </div>
              )}

              <div className="form-group">
                <label>E-posta{personelBagliMi && bagliPersonel.email ? ' (Personelden)' : ''}</label>
                <input
                  className="form-control"
                  value={form.email || ''}
                  onChange={e => setForm({ ...form, email: e.target.value })}
                  disabled={personelBagliMi && !!bagliPersonel.email}
                  style={personelBagliMi && bagliPersonel.email ? { background: '#f9f9f9', color: '#555' } : {}}
                />
              </div>

              <div className="form-group">
                <label>Rol *</label>
                <select className="form-control" value={form.rol || ''} onChange={e => {
                  const yeniRol = e.target.value;
                  const isletmeRol = ['isletme_mudur', 'isletme_personel'].includes(yeniRol);
                  setForm({ ...form, rol: yeniRol, isletme_id: isletmeRol ? form.isletme_id : null });
                }}>
                  {roller.map(r => <option key={r.kod} value={r.kod}>{r.ad}</option>)}
                </select>
              </div>

              <div className="form-group">
                <label>İşletme{isletmeGerekli ? ' *' : ''}{personelBagliMi && bagliPersonel.isletme_id ? ' (Personelden)' : ''}</label>
                <select
                  className="form-control"
                  value={form.isletme_id || ''}
                  onChange={e => setForm({ ...form, isletme_id: e.target.value ? Number(e.target.value) : null })}
                  disabled={personelBagliMi && !!bagliPersonel.isletme_id}
                  style={personelBagliMi && bagliPersonel.isletme_id ? { background: '#f9f9f9', color: '#555' } : {}}
                >
                  <option value="">{isletmeGerekli ? 'Seçiniz' : '— Seçmeyebilirsiniz —'}</option>
                  {isletmeler.map(i => <option key={i.id} value={i.id}>{i.ad}</option>)}
                </select>
              </div>
              {!isletmeGerekli && (
                <div className="form-group">
                  <label>Çalıştığı Birim / Daire</label>
                  <select
                    className="form-control"
                    value={form.birim_adi || ''}
                    onChange={e => setForm({ ...form, birim_adi: e.target.value })}
                  >
                    <option value="">— Seçiniz —</option>
                    {orgBirimler.map(b => (
                      <option key={b.id} value={b.ad}>{b.ad}</option>
                    ))}
                  </select>
                </div>
              )}
            </div>
            <div className="modal-footer">
              <button className="btn" onClick={kapat} style={{ background: '#eee' }}>İptal</button>
              <button className="btn btn-primary" onClick={kaydet}>Kaydet</button>
            </div>
          </div>
        </div>
      )}

      {/* Şifre Modal */}
      {sifreModal && (
        <div className="modal-overlay" onClick={kapat}>
          <div className="modal" onClick={e => e.stopPropagation()}>
            <div className="modal-header">
              <h3>Şifre Değiştir — {secili?.ad_soyad}</h3>
              <button className="modal-close" onClick={kapat}>×</button>
            </div>
            <div className="modal-body">
              {hata && <div className="alert alert-danger">{hata}</div>}
              <div className="form-group">
                <label>Yeni Şifre (min. 6 karakter)</label>
                <input className="form-control" type="password" value={yeniSifre} onChange={e => setYeniSifre(e.target.value)} />
              </div>
            </div>
            <div className="modal-footer">
              <button className="btn" onClick={kapat} style={{ background: '#eee' }}>İptal</button>
              <button className="btn btn-primary" onClick={sifreDegistir}>Kaydet</button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
